import React from "react";
import Tr from "../../common/table/tr";
import Td from "../../common/table/td";

export function IndicadorDemandasAtingidasUltrapassagemMobile(props) {
    if (!props.item.id) {
        return (
            <>
                <div title={props.titleGrupoFaturamentoTipoMedicao}
                    style={{ fontWeight: "bold", color: "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {props.grupoFaturamentoTipoMedicao}
                </div>

                <div style={{ backgroundColor: props.item.id_grupo_faturamento == 3 ? "#000" : "#ef2028", color: "#ffffff", padding: 5, borderRadius: "0.3rem", textAlign: "center" }}>
                    <div style={{ width: "100%", minWidth: 150 }}>A UC não possui contrato de demanda</div>
                </div>
            </>
        );
    }

    return props.item.contrato_demanda_sazonal ? (
        // CONTRATO SAZONAL
        <table style={{ margin: "0 auto", border: "2px solid #FFF", borderCollapse: "collapse", textAlign: "center", transform: "translateY(-10px)" }}>
            <tbody>
                <Tr>
                    <Td color={props.item.atingidas >= 2 ? "#fff" : "#000"} backgroundColor={"#fff0"} alignCenter>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", minHeight: 32, textAlign: "center", fontWeight: "bold", fontSize: "0.85rem", color: "#000", backgroundColor: "#FFF", padding: "4px 6px", marginBottom: 6, borderBottom: "1px solid rgba(255,255,255,0.45)" }}>
                            Resumo das Demandas Atingidas
                        </div>

                        <div title={props.titleGrupoFaturamentoTipoMedicao} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8, fontWeight: "bold", color: props.color || "#000", textAlign: "center", marginBottom: 4 }}>
                            <span>Contrato Sazonal</span>
                            <span>{props.grupoFaturamentoTipoMedicao}</span>
                        </div>

                        {/* DEMANDAS ATINGIDAS + ULTRAPASSAGENS */}
                        <div style={{ display: "flex", alignItems: "stretch", justifyContent: "center", width: "100%", marginBottom: "7px" }}>
                            <div style={{ display: "flex", flexWrap: "nowrap", fontWeight: "bold", backgroundColor: "#FFF", border: `3px solid ${props.item.atingidas >= 3 ? "#0bf97f" : "#000"}` }}>
                                <div style={{ margin: 3, display: "flex", alignItems: "center", flexWrap: "nowrap", fontWeight: "bold", backgroundColor: "#FFF", width: "100%", color: props.item.atingidas >= 3 ? "#0f6b31" : "#000" }}>
                                    <span style={{ padding: "4px 10px", height: 30, display: "flex", alignItems: "center", backgroundColor: props.item.atingidas > 0 ? "#6affa2" : "#FFF" }}>
                                        {props.item.atingidas}
                                    </span>

                                    {new Array(3).fill(null).map((_, i) => (
                                        <div key={i} style={{ width: 25, height: 30, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: i + 1 <= props.item.atingidas ? "#6affa2" : "#FFF" }}>
                                            <i style={{ color: i + 1 <= props.item.atingidas ? "#006224" : "#E22", fontSize: "0.8rem" }}
                                               className={i + 1 <= props.item.atingidas ? "fas fa-check" : "fas fa-minus"}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div title={`Total de ultrapassagens:${parseInt(props.item.ultrapassagens || 0)}`}
                                style={{ width: 42, minWidth: 42, marginLeft: 3, backgroundColor: parseInt(props.item.ultrapassagens) ? "#fa3c3c" : "black", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <i className="fas fa-angle-double-up" style={{ fontSize: "1rem", marginRight: 3 }}></i>
                                <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>{props.item.ultrapassagens || 0}</span>
                            </div>
                        </div>

                        {/* INÍCIO / FIM - MOBILE */}
                        <table style={{ margin: "0 auto", borderCollapse: "collapse", width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "2px 5px", fontSize: "0.8rem", color: "#FFF" }}>
                                        Início
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "2px 5px", fontSize: "0.8rem", color: "#FFF" }}>
                                        {props.sazonalidadeDiferenteDaUC ? "-" : `${String(props.item.competencia_inicio).substring(4, 6)}/${String(props.item.competencia_inicio).substring(0, 4)}`}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "2px 5px", fontSize: "0.8rem", color: "#FFF" }}>
                                        Fim
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "2px 5px", fontSize: "0.8rem", color: "#FFF" }}>
                                        {props.sazonalidadeDiferenteDaUC ? "-" : `${String(props.item.competencia_fim).substring(4, 6)}/${String(props.item.competencia_fim).substring(0, 4)}`}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Td>
                </Tr>
            </tbody>
        </table>
    ) : (
        // CONTRATO NÃO SAZONAL
        <table style={{ margin: "0 auto", border: "2px solid #FFF", borderCollapse: "collapse", textAlign: "center", transform: "translateY(-15px)" }}>
            <tbody>
                <Tr>
                    <Td backgroundColor={"#fff0"} alignCenter>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", minHeight: 32, textAlign: "center", fontWeight: "bold", fontSize: "0.85rem", color: "#000", backgroundColor: "#FFF", padding: "4px 6px", marginBottom: 6 }}>
                            Resumo das Demandas Atingidas
                        </div>

                        <div title={props.titleGrupoFaturamentoTipoMedicao}
                            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8, fontWeight: "bold", color: props.color || "#000", textAlign: "center", marginBottom: 4 }}>
                            <span>Contrato Não Sazonal</span>
                            <span>{props.grupoFaturamentoTipoMedicao}</span>
                        </div>

                        {/* VERDE / VERMELHO */}
                        <div style={{ display: "flex", alignItems: "stretch", justifyContent: "center", width: "100%" }}>
                            <div title="Demandas Atingidas sem Ultrapassagens" style={{ flex: 1, backgroundColor: "#28a745", color: "#FFF", padding: "5px 0", textAlign: "center" }}>
                                <div><i className="fas fa-angle-up"></i></div>
                                <div style={{ fontWeight: "bold" }}>{props.item.atingidas - (props.item.ultrapassagens || 0) || 0}</div>
                            </div>

                            <div title="Demandas Atingidas com Ultrapassagens" style={{ flex: 1, backgroundColor: "#dc3545", color: "#FFF", padding: "5px 0", textAlign: "center" }}>
                                <div><i className="fas fa-angle-double-up"></i></div>
                                <div style={{ fontWeight: "bold" }}>{props.item.ultrapassagens || 0}</div>
                            </div>
                        </div>

                        {/* 1º MÊS / Nº MESES */}
                        <table
                            style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "3px 6px", width: "50%", fontSize: "0.8rem", textAlign: "center" }}>
                                        <div style={{ fontWeight: "bold" }}>1º Mês</div>

                                        <div>
                                            {!props.item.id || props.sazonalidadeDiferenteDaUC
                                                ? "-"
                                                : `${String(props.item.competencia_base_sazonalidade).substring(4, 6)}/${String(props.item.competencia_base_sazonalidade).substring(0, 4)}`}
                                        </div>
                                    </td>

                                    <td style={{ border: "1px solid #ddd", padding: "3px 6px", width: "50%", fontSize: "0.8rem", textAlign: "center" }}>
                                        <div style={{ fontWeight: "bold" }}>Nº Meses</div>

                                        <div>{props.item.id ? props.item.meses_nao_sazonal || 1 : "-"}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Td>
                </Tr>
            </tbody>
        </table>
    );
}
